import { useTranslation } from 'react-i18next';
import { useResizeWidth } from '~/hooks/resize';
import { FilterListDrag, FilterListSidebar } from '.';

interface FilterSidebarProps {
  children: React.ReactNode;
  open: boolean;
  persistAs?: string;
}

export const FilterSidebar = ({ children, open, persistAs }: FilterSidebarProps) => {
  const { t } = useTranslation();
  const { max, min, onKeyDown, onResize, onToggle, resizableRef, width } = useResizeWidth({
    initial: 250,
    max: 500,
    min: 250,
    persistAs,
  });

  return (
    <FilterListSidebar open={open} ref={resizableRef} width={width}>
      {children}
      <FilterListDrag
        aria-label={t('common.filter.resize_handle')}
        aria-orientation="vertical"
        aria-valuemax={max}
        aria-valuemin={min}
        aria-valuenow={width}
        onClick={onToggle}
        onKeyDown={onKeyDown}
        onMouseDown={onResize}
        role="separator"
        tabIndex={0}
      />
    </FilterListSidebar>
  );
};
